import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const benignResizeObserverErrors = new Set([
  "ResizeObserver loop completed with undelivered notifications.",
  "ResizeObserver loop limit exceeded",
]);

if (typeof window !== "undefined") {
  window.addEventListener("error", (event) => {
    if (benignResizeObserverErrors.has(event.message)) {
      event.preventDefault();
      event.stopImmediatePropagation();

      window.setTimeout(() => {
        const overlay = document.getElementById(
          "webpack-dev-server-client-overlay",
        );

        if (overlay?.style) {
          overlay.style.display = "none";
        }
      }, 0);
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
